/**
 * Coach Notes Service
 * Fetches and marks read the standalone notes a coach posts to a client.
 * A note is either a standalone broadcast (check_in_id = null, migration 041)
 * or a Coach Review attached to a specific check-in (check_in_id set,
 * migration 052) — the same table serves both, distinguished by that column.
 */
import { supabase } from '../supabase';

export const getCoachNotes = async (userId) => {
  const { data, error } = await supabase
    .from('coach_notes')
    .select('id, message, created_at, read_at, check_in_id')
    .eq('user_id', userId)
    .order('created_at', { ascending: false });

  if (error) throw error;
  return data || [];
};

export const markCoachNoteRead = async (noteId) => {
  const { error } = await supabase
    .from('coach_notes')
    .update({ read_at: new Date().toISOString() })
    .eq('id', noteId)
    .is('read_at', null);

  if (error) throw error;
};

/**
 * Insert a coach note. Pass checkInId to attach it to a specific check-in as
 * a Coach Review (rendered on that check-in's detail screen); omit it for a
 * standalone broadcast note (the original migration-041 behavior).
 */
export const addCoachNote = async (userId, coachId, message, checkInId = null) => {
  const { data, error } = await supabase
    .from('coach_notes')
    .insert({ user_id: userId, coach_id: coachId, message, check_in_id: checkInId })
    .select()
    .single();

  if (error) throw error;
  return data;
};
